import { useState } from 'react';
import styled, { css } from 'styled-components';

const ItemsContainer = styled.div`
    margin-top: 8px;
`;

const itemHeight = 30;

const itemSpacing = 4;
const collapsed = css`
    width: 0;
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
`;

const SpacerInner = styled.div`
    width: 100%;
    border-radius: 4px;
    height: ${itemHeight}px;
    box-sizing: border-box;
    background-color: #e0e0e0;
`;

const DraggableListItemContainer = styled.div`
    display: inline-block;
    overflow: hidden;
    padding: 0px ${itemSpacing}px;
    box-sizing: border-box;

    ${(props) => props.$width === 0 && collapsed}

    ${SpacerInner} {
        width: ${(props) =>
            `${props.$width}${typeof props.$width !== 'string' && 'px'}`};
    }
`;

const DraggableListItem = styled.div`
    border: 1px solid #000;
    border-radius: 4px;
    padding: 0px 8px;
    line-height: ${itemHeight - 4}px;
    background-color: #f9f9f9;
    cursor: ${(props) => (props.dragActive ? 'grabbing' : 'grab')};
    user-select: none;
    height: ${itemHeight}px;
    box-sizing: border-box;
    overflow: hidden;
`;

const Spacer = (props) => (
    <DraggableListItemContainer {...props}>
        <SpacerInner />
    </DraggableListItemContainer>
);

const DragPreview = styled(DraggableListItem)`
    position: fixed;
    z-index: 1000;
    background-color: #f9f9f9;
    pointer-events: none;
    user-select: none;
    cursor: grabbing;
`;

const Label = styled.div``;

const HelperText = styled.div`
    font-size: 0.8rem;
    font-style: italic;
`;

const ToolContainer = styled.div`
    padding-bottom: 16px;

    ${(props) =>
        props.isDragging &&
        css`
            cursor: grabbing;
        `}
`;

const ListOrder = ({ label, list, setList, helpText }) => {
    // const [list, setList] = useState(items);

    const [draggingItem, setDraggingItem] = useState(null); // Track the currently dragged item
    const [targetIndex, setTargetIndex] = useState(null);
    const [spacerWidth, setSpacerWidth] = useState(0);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 }); // Track mouse position

    if (!list || !Array.isArray(list)) {
        return null;
    }

    const getDragStartHandler = (itemIndex) => (event) => {
        setDraggingItem(itemIndex);
        setTargetIndex(itemIndex);
        const width = event.currentTarget.getBoundingClientRect().width;
        setSpacerWidth(width);
        // Track the mouse position
        const { clientX, clientY } = event;
        setMousePosition({ x: clientX, y: clientY });
    };

    // const getDragOverHandler = (itemIndex) => (event) => {
    //     event.preventDefault(); // Allow dropping by preventing the default behavior
    //     setTargetIndex(itemIndex);
    // };

    const getMouseMoveItemHandler = (itemIndex) => (event) => {
        const element = event.currentTarget; // The element being hovered
        const rect = element.getBoundingClientRect(); // Get the element's bounding box
        const mouseX = event.clientX; // Get the mouse's X position
        const elementMidX = rect.left + rect.width / 2; // Calculate the midpoint of the element

        let nextTargetIndex = itemIndex;
        const moveRight = itemIndex > draggingItem;
        const rightHalf = mouseX > elementMidX;
        if (moveRight) nextTargetIndex -= 1; // target is higher than source
        if (rightHalf) nextTargetIndex += 1; // Mouse is on the right half

        setTargetIndex(nextTargetIndex);
    };

    const handleDragLeave = () => {
        // setTargetIndex(null);
    };

    const handleDrop = (event) => {
        event.preventDefault();

        if (targetIndex !== draggingItem) {
            const updatedList = [...list];
            const [draggedItem] = updatedList.splice(draggingItem, 1);
            updatedList.splice(targetIndex, 0, draggedItem);

            setList(updatedList);
        }

        setTargetIndex(null); // Clear the drag-over index after dropping
        setDraggingItem(null); // Clear the dragging item
    };

    const cancelDrag = () => {
        setDraggingItem(null); // Clear the dragging item when drag ends
        setTargetIndex(null); // Clear the drag-over index
    };

    const handleMouseMove = (event) => {
        // Update the mouse position while dragging
        const { clientX, clientY } = event;
        setMousePosition({ x: clientX, y: clientY });
    };

    const listWithSpace = list.reduce(
        (prevList, curItem, i) => {
            return [
                ...prevList,
                { label: curItem, index: i },
                { spacer: true, position: i + 1 },
            ];
        },
        [{ spacer: true, position: 0 }]
    );

    const isDragging = draggingItem !== null;

    let visibleTargetSpace = null;
    if (isDragging) {
        visibleTargetSpace = targetIndex + (targetIndex < draggingItem ? 0 : 1);
        // visibleTargetSpace = targetIndex + 1;
    }

    return (
        <ToolContainer
            onMouseMove={isDragging ? handleMouseMove : null}
            onMouseUp={handleDrop}
            onMouseLeave={cancelDrag}
            isDragging={isDragging}
        >
            {label && <Label>{label}</Label>}
            {helpText && <HelperText>{helpText}</HelperText>}
            <ItemsContainer>
                {listWithSpace.map((item, index) => {
                    if (item.spacer) {
                        return (
                            <Spacer
                                key={`__spacer_${item.position}__`}
                                // style={{
                                //     width:
                                //         visibleTargetSpace === item.position
                                //             ? spacerWidth
                                //             : 0,
                                // }}
                                // collapsed={visibleTargetSpace !== item.position}
                                $width={
                                    visibleTargetSpace === item.position
                                        ? spacerWidth
                                        : 0
                                }
                            />
                        );
                    }
                    return (
                        <DraggableListItemContainer
                            $width={draggingItem === item.index ? 0 : 'auto'}
                            key={item.label}
                            onMouseMove={
                                isDragging
                                    ? getMouseMoveItemHandler(item.index)
                                    : null
                            }
                        >
                            <DraggableListItem
                                onMouseDown={getDragStartHandler(item.index)}
                                onMouseLeave={handleDragLeave}
                                dragActive={isDragging}
                            >
                                {item.label}
                            </DraggableListItem>
                        </DraggableListItemContainer>
                    );
                })}
            </ItemsContainer>
            {isDragging && (
                <DragPreview
                    style={{
                        top: mousePosition.y,
                        left: mousePosition.x,
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    {list[draggingItem]}
                </DragPreview>
            )}
        </ToolContainer>
    );
};

export default ListOrder;
